const BoxTypeList = () => import('Views/boxType/boxType-list');
const BoxTypeAddEdit = () => import('Views/boxType/boxType-addEdit');
const BoxTypeDetail = () => import('Views/boxType/boxType-detail');

export default[
  { path: '/boxType-list', component: BoxTypeList },
  { path: '/boxType-add', component: BoxTypeAddEdit },
  { path: '/boxType-edit/:id', component: BoxTypeAddEdit },
  { path: '/boxType-detail/:id', component: BoxTypeDetail },
];



// WEBPACK FOOTER //
// ./src/router/boxType.js